export function Ico18DoubleArrowRight({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.375 15.1875L15 9.5625L9.375 3.9375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M2.375 15.1875L8 9.5625L2.375 3.9375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
